import { callZigzagFunction } from '../../callZigzagFunction';

// agree ad notification
// 지그재그 마케팅 앱 푸시(≠ 기기 알림) 동의 처리
export const aan = () => {
  callZigzagFunction('aan')();
};
